var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.498 139.308L224.439 171.758L294.934 140.055L200.71 103.352L136.498 139.308Z",
    fill: "#0C1A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 132.514L240.599 164.595L296.258 139.858L205.039 107.777L149.381 132.514Z",
    fill: "#B0B0B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.066 116.4L240.465 145.377L284.992 125.52L204.593 96.543L160.066 116.4Z",
    fill: "#373943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.651 101.331L285.049 130.309L285.049 122.063L204.65 93.0859L204.651 101.331Z",
    fill: "#4A4D5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.644 101.314L160.172 121.152L160.172 112.924L204.643 93.0859L204.644 101.314Z",
    fill: "#202129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.646 101.314L202.65 102.206L198.342 95.8894L204.646 93.0859L204.646 101.314Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.645 101.314L280.376 128.673V120.267L204.645 93.0859L204.645 101.314Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.643 101.316L276.244 127.132L273.443 128.138L202.652 102.211L204.643 101.316Z",
    fill: "#21232C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.597 146.041L149.379 113.96L205.037 89.2227L296.256 121.304L240.597 146.041ZM240.523 141.921L160.124 112.944L204.651 93.0872L285.05 122.064L240.523 141.921Z",
    fill: "#CBE6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.597 146.041L149.379 113.96L205.037 89.2227L296.256 121.304L240.597 146.041ZM240.523 141.921L160.124 112.944L204.651 93.0872L285.05 122.064L240.523 141.921Z",
    fill: "url(#paint0_linear_569_27167)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.381 113.957L240.599 146.032V164.591L149.381 132.51V113.957Z",
    fill: "#213547"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.258 121.305L240.6 146.041V164.595L296.258 139.858V121.305Z",
    fill: "#416E97"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.908 108.267L254.441 132.47L258.726 130.229L193.06 106.719L189.908 108.267Z",
    fill: "#21232C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.666 105.117L256.286 128.916L256.286 131.194L191.666 107.395L191.666 105.117Z",
    fill: "#CC8259"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.666 105.113L256.286 128.912L258.871 127.565L194.251 103.766L191.666 105.113Z",
    fill: "#FFB287"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M235.324 120.965L256.283 128.634L258.868 127.287L237.91 119.617L235.324 120.965Z",
    fill: "#E87F45"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.518 123.295L251.978 126.837L253.427 126.086L243.966 122.543L242.518 123.295Z",
    fill: "#563320"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M255.767 128.225L255.535 127.697L256.984 126.945L257.28 127.383L255.767 128.225Z",
    fill: "#EC9D70"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242.804 122.977L255.537 127.703L255.767 128.233L251.876 126.795L251.662 126.524L242.515 123.106L242.804 122.977Z",
    fill: "#CC8259"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.803 122.974L255.536 127.701L256.984 126.95L244.251 122.223L242.803 122.974Z",
    fill: "#FFB287"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242.799 122.975L242.527 123.099L243.976 122.347L244.248 122.223L242.799 122.975Z",
    fill: "#B88467"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M256.284 131.534L256.283 128.633L258.869 127.285L258.87 130.186L256.284 131.534Z",
    fill: "#783814"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M235.324 120.961L256.292 128.652V131.555L235.324 123.82V120.961Z",
    fill: "#9E4E21"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M277.754 129.515L277.754 125.246L286.101 121.598L294.937 121.948L277.754 129.515Z",
    fill: "#32485C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M291.645 141.911L277.736 129.487L296.316 121.297L296.257 139.857L291.645 141.911Z",
    fill: "#213547"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.686 88.6534L278.084 117.631L320.875 116.114L240.477 87.1367L197.686 88.6534Z",
    fill: "#CBE6FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197.686 88.6534L278.084 117.631L320.875 116.114L240.477 87.1367L197.686 88.6534Z",
    fill: "url(#paint1_linear_569_27167)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.082 124.35V117.634L320.873 116.117L320.874 122.016L278.082 124.35Z",
    fill: "#416E97"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M278.094 124.362V117.646L197.686 88.6523L197.687 94.5516L278.094 124.362Z",
    fill: "#213547"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27167",
    x1: 263.089,
    y1: 106.198,
    x2: 252.987,
    y2: 132.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27167",
    x1: 266.41,
    y1: 91.0453,
    x2: 258.184,
    y2: 111.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool03);
export default __webpack_public_path__ + "static/media/school_03.c5e9a1f91fd31e557c802fdd6609ae72.svg";
export { ForwardRef as ReactComponent };